import * as React from "react";
import { SortableContainer as sortableContainerHOC } from "react-sortable-hoc";
import { SortableHandle as sortableHandleHOC } from "react-sortable-hoc";
import { SortableElement as sortableElementHOC } from "react-sortable-hoc";

interface ISortableContainerProps {
    children: React.ReactNode;
    as?: keyof JSX.IntrinsicElements | React.ComponentType;
}

interface ISortableHandleProps {
    children: React.ReactNode;
}

interface ISortableElementProps {
    children: React.ReactNode;
}

export const SortableContainer = sortableContainerHOC(
    ({ as: Comp = "div", children }: ISortableContainerProps) => {
        return <Comp>{children}</Comp>;
    },
);

export const SortableHandle = sortableHandleHOC(
    ({ children }: ISortableHandleProps) => {
        return <>{children}</>;
    },
);

export const SortableElement = sortableElementHOC(
    ({ children }: ISortableElementProps) => {
        return <>{children}</>;
    },
);
